class NavMain {
	constructor() {
		resizeCallbacks.push(this);
		let that = this;
		this.navIsOpened = false;

		/**
		 * Open menu toggle {
		 */
		$('.nav-main__trigger').on('click', function () {
			$('body').addClass('nav-is-opened');
			that.navIsOpened = true;
		});

		$('.nav-main__close').on('click', function () {
			$('body').removeClass('nav-is-opened');
			that.navIsOpened = false;
		});

		/**
		 * Changement du look de la nav au scroll
		 */
		let navScroll = ScrollTrigger.create({
			start: "top -30",
			endTrigger: "html",
			toggleClass: {
				className: 'header-main--scrolled',
				targets: '.header-main'
			}
		});

		const showAnim = gsap.from('.header-main', {
			yPercent: -100,
			paused: true,
			duration: 0.5,
			ease: 'expo.out'
		}).progress(1);

		$(window).on('wheel', function (e) {
			if (!that.navIsOpened) {
				if (e.originalEvent.deltaY > 30) {
					showAnim.reverse();
				} else if (e.originalEvent.deltaY < -30) {
					showAnim.play();
				}
			}
		});
	}

	resize() {
		this.navIsOpened = false;
		$('body').removeClass('nav-is-opened');
	}
}